import { Button, Stack } from '@mui/material';
import { EXAMPLE_TAGS } from '../../utils/constants';
import { alphaVar } from '../../theme/helpers/color-helpers';
import { BPS_BLUE, BPS_LIGHT_GREY, BPS_RED, WHITE } from '../../theme/theme-colors';
import type { CssVarsTheme } from '@mui/material/styles';

interface ExampleControlsProps {
  handleClick: (tag: string) => void;
  filterTag: string;
}

const ExampleControls = ({ handleClick, filterTag }: ExampleControlsProps) => {
  return (
    <Stack direction={'row'} spacing={2}>
      {EXAMPLE_TAGS.map((tag) => {
        const isSelected = filterTag === tag;
        return (
          <Button
            key={tag}
            variant="contained"
            onClick={() => handleClick(tag)}
            sx={(theme) => {
              const t = theme as unknown as CssVarsTheme;
              return {
                borderRadius: 5,
                fontFamily: theme.typography.fontFamily,
                ...(isSelected
                  ? {
                      backgroundColor: alphaVar(t, t.vars?.palette?.secondary?.mainChannel, BPS_RED, 0.12),
                      color: t.vars?.palette?.text?.primary || theme.palette.text.primary,
                      fontWeight: 600,
                      '&:hover': {
                        backgroundColor: alphaVar(t, t.vars?.palette?.secondary?.mainChannel, BPS_RED, 0.16),
                        ...theme.applyStyles('light', {
                          color: BPS_BLUE,
                        }),
                        ...theme.applyStyles('dark', {
                          color: WHITE,
                        }),
                      },
                    }
                  : {
                      ...theme.applyStyles('light', {
                        backgroundColor: BPS_LIGHT_GREY,
                        color: BPS_BLUE,
                      }),
                      ...theme.applyStyles('dark', {
                        backgroundColor: theme.vars?.palette?.spheroGrey?.main || theme.palette.spheroGrey.main,
                        color: theme.vars?.palette?.text?.primary || theme.palette.text.primary,
                      }),
                      '&:hover': {
                        ...theme.applyStyles('light', {
                          backgroundColor: alphaVar(t, undefined, BPS_LIGHT_GREY, 0.7),
                          color: BPS_BLUE,
                        }),
                        ...theme.applyStyles('dark', {
                          backgroundColor: theme.vars?.palette?.action?.hover || theme.palette.action.hover,
                          color: theme.vars?.palette?.text?.primary || theme.palette.text.primary,
                        }),
                      },
                    }),
              };
            }}
          >
            {tag}
          </Button>
        );
      })}
    </Stack>
  );
};

export default ExampleControls;
